import script from "./ExchangeRateView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExchangeRateView.vue?vue&type=script&lang=ts&setup=true"

import "./ExchangeRateView.vue?vue&type=style&index=0&id=c0ca4310&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0ca4310"]])

export default __exports__